import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import type { CaseSimulatorBarcodeMode } from '../../../types/features/caseSimulator';

type CaseSimulatorBarcodeModeSelectorProps = {
  barcodeMode: CaseSimulatorBarcodeMode;
  onBarcodeModeChange: (mode: CaseSimulatorBarcodeMode) => void;
};

const CaseSimulatorBarcodeModeSelector: React.FC<CaseSimulatorBarcodeModeSelectorProps> = React.memo(({
  barcodeMode,
  onBarcodeModeChange,
}) => (
  <Box
    className="case-simulator-screen-only"
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      gap: 1.25,
      justifyContent: 'flex-end',
      mb: 1.5,
      mt: 1.5,
    }}
  >
    <FormControlLabel
      label="PLU Barcode"
      control={(
        <Checkbox
          checked={barcodeMode === 'plu'}
          onChange={(event) => onBarcodeModeChange(event.target.checked ? 'plu' : 'ticket')}
          size="small"
          inputProps={{ 'aria-label': 'Show PLU barcode' }}
          sx={{
            color: '#2C6CA0',
            p: 0.5,
            '&.Mui-checked': {
              color: '#2C6CA0',
            },
          }}
        />
      )}
      sx={{
        m: 0,
        '& .MuiFormControlLabel-label': {
          color: '#2B3445',
          fontSize: 14,
          fontWeight: 700,
        },
      }}
    />
  </Box>
));

CaseSimulatorBarcodeModeSelector.displayName = 'CaseSimulatorBarcodeModeSelector';

export default CaseSimulatorBarcodeModeSelector;
